import { render, staticRenderFns } from "./DvDeviceFigure.vue?vue&type=template&id=ec57daa2&scoped=true&"
import script from "./DvDeviceFigure.vue?vue&type=script&lang=js&"
export * from "./DvDeviceFigure.vue?vue&type=script&lang=js&"
import style0 from "./DvDeviceFigure.vue?vue&type=style&index=0&id=ec57daa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec57daa2",
  null
  
)

export default component.exports